import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const AdminSettings: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useLanguage();

    return (
        <div className="container mx-auto py-8 px-4">
            <div className="flex justify-between items-center mb-8">
                <h1 className="text-3xl font-bold bg-gradient-to-r from-red-400 to-pink-500 bg-clip-text text-transparent">
                    {t('admin.settings.title')}
                </h1>
                <button
                    onClick={() => navigate('/admin')}
                    className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors"
                >
                    {t('admin.back_to_dashboard')}
                </button>
            </div>

            <div className="bg-gray-800 rounded-lg border border-gray-700 p-6 max-w-2xl">
                <div className="space-y-6">
                    <div>
                        <h3 className="text-xl font-semibold mb-4 text-white">{t('admin.settings.general')}</h3>
                        <div className="space-y-4">
                            <div className="flex items-center justify-between">
                                <label className="text-gray-300">{t('admin.settings.site_name')}</label>
                                <input type="text" defaultValue="ServeRS" className="bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white w-64" />
                            </div>
                            <div className="flex items-center justify-between">
                                <label className="text-gray-300">{t('admin.settings.maintenance')}</label>
                                <div className="relative inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
                                    <input type="checkbox" name="toggle" id="toggle" className="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" />
                                    <label htmlFor="toggle" className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-600 cursor-pointer"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="border-t border-gray-700 pt-6">
                        <h3 className="text-xl font-semibold mb-4 text-white">{t('admin.settings.email')}</h3>
                        <div className="space-y-4">
                            <div className="flex items-center justify-between">
                                <label className="text-gray-300">{t('admin.settings.smtp_host')}</label>
                                <input type="text" placeholder="smtp.example.com" className="bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white w-64" />
                            </div>
                            <div className="flex items-center justify-between">
                                <label className="text-gray-300">{t('admin.settings.smtp_port')}</label>
                                <input type="number" placeholder="587" className="bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white w-24" />
                            </div>
                        </div>
                    </div>

                    <div className="pt-6">
                        <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors">
                            {t('admin.settings.save')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminSettings;
